



















































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

import AnalyticsCard from '@/componentsV2/molecules/AnalyticsCard/AnalyticsCard.vue';
import SectionWrapper, {
  SectionWrapperConfig
} from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import DateFilter from '@/components/molecules/DateFilter/DateFilter.vue';
import { AnalyticsCardListItem } from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';
import AnalyticsCardList from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';
import FilterByTags from '@/componentsV2/organisms/FilterByTags/FilterByTags.vue';
import UseFilterByTags from '@/componentsV2/organisms/FilterByTags/UseFilterByTags.vue';
import { TextField } from '@/components/atoms';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import {
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';

import { IPeriod } from '@/models/period';
import PerformanceUtils from '@/utils/PerformanceUtils';
import DateUtils from '@/utils/DateUtils';

type TFilter = {
  label: string;
  type: string;
};

type TAnalytics = {
  title: string;
  columns?: number;
  items: AnalyticsCardListItem[];
};

type TSearch = {
  placeholder: string;
  term: string;
};

type TCustomFitler = {
  options: CustomSelectModel;
  maxHeight?: string;
  selectAllText?: string;
};

enum EDatepickerPosition {
  RIGHT_OF_THE_TITLE = 'rightOfTheTitle',
  RIGHT_OF_THE_SEARCH = 'rightOfTheSearch'
}

type SectionDataConfig = SectionWrapperConfig & {
  datepickerPosition?: EDatepickerPosition;
};

type GATracking = {
  eventCategory: string;
  eventAction: string;
};

type GATrackingConfig = {
  period?: GATracking;
  search?: GATracking;
  select?: GATracking;
};

type FilterGATracking = {
  eventCategory: string;
  eventAction: string;
};

@Component({
  components: {
    SectionWrapper,
    AnalyticsCard,
    DateFilter,
    AnalyticsCardList,
    FilterByTags,
    TextField,
    CustomSelect,
    Typography
  }
})
export default class SectionData extends Mixins(UseFilterByTags) {
  @Prop(String) title?: string;
  @Prop(String) description?: string;
  @Prop(String) filterByTagLabel?: string;
  @Prop() config?: SectionDataConfig;
  @Prop({ default: () => [] }) filters!: TFilter;
  @Prop({ default: () => [] }) filterGATracking?: FilterGATracking;
  @Prop() analytics?: TAnalytics;
  @Prop({ default: true }) filterPeriod?: boolean;
  @Prop({ default: () => PerformanceUtils.defaultPeriod() }) period?: IPeriod;
  @Prop() search?: TSearch;
  @Prop() customFilter?: TCustomFitler;
  @Prop({ default: '' }) analyticsInstanceId?: string;
  @Prop() gaTracking?: GATrackingConfig;

  debounceSearch: any = null;

  get EDatepickerPosition() {
    return EDatepickerPosition;
  }

  get configSettings(): SectionDataConfig {
    return {
      datepickerPosition: EDatepickerPosition.RIGHT_OF_THE_TITLE,
      ...this.config
    };
  }

  created() {
    this.debounceSearch = debounce((fieldValue: string) => {
      this.$emit('search-change', fieldValue);

      if (this.gaTracking && this.gaTracking.search) {
        this.$analytics({
          ...this.gaTracking.search,
          eventLabel: fieldValue
        });
      }
    }, 800);
  }

  handleSelectChange(event: CustomSelectOption[]) {
    this.$emit('custom-filter-change', event);

    const [selectedOption] = event;

    if (this.gaTracking && this.gaTracking.select) {
      this.$analytics({
        ...this.gaTracking.select,
        eventLabel: selectedOption.label
      });
    }
  }

  handlePeriodChange(period: IPeriod) {
    this.$emit('period-change', period);

    if (this.gaTracking && this.gaTracking.period) {
      const formatDate = (date: string) => DateUtils.formattedDate({ date });

      this.$analytics({
        ...this.gaTracking.period,
        eventLabel: `${formatDate(period.start)} - ${formatDate(period.end)}`
      });
    }
  }
}
